import { parentalControlValues } from "../utils/parentalControlUtils";
import { getCommonParams } from "../services/analyticsService";
import { getAppState } from "../state";
const NOT_SELECTED = "not selected";
const defaultEventsList = [
  "switch_profile_clicked",
  "profiles_list_viewed",
  "profiles_edit_start",
  "profile_clicked",
  "add_profile_click",
  "profile_created",
  "avatar_setting_clicked",
  "profile_name_setting_clicked",
  "language_setting_clicked",
  "profile_lock_setting_clicked",
  "viewing_restrictions_setting_clicked",
  "profile_pin_success",
  "profile_pin_failed",
  "profile_pin_cancel_click",
  "profile_pin_changed",
  "profile_pin_removed",
  "account_password_success",
  "account_password_failed",
  "account_password_cancel_click",
  "profile_delete_keep_clicked",
  "view_profile_restrictions",
  "manage_profiles_clicked",
  "account_details_clicked",
  "devices_and_access_clicked",
  "payment_history_clicked"
];
const multipleProfileCommonParams = profileData => {
  return {
    a_profile_id: getAppState().currentProfileId || "",
    profile_name: !profileData?.profileName ? NOT_SELECTED : profileData.profileName,
    profile_lock: profileData?.isProfileLocked || profileData?.isKidLockEnabled ? true : false,
    profile_language: profileData?.language || "",
    profile_access_type: profileData?.profileCategory || "",
    viewing_restrictions: parentalControlValues(profileData?.parentalControl)
  };
};
const updatedProfileParams = updatedProfile => {
  return {
    save_cta_location: updatedProfile.location,
    avatar_changed: updatedProfile.isAvatarChange || false,
    profile_name_changed: updatedProfile.isProfileNameChange || false,
    profile_lock_changed: updatedProfile.isProfileLockChange || false,
    kids_profile_changed: updatedProfile.isProfileCategoryChange || false,
    viewing_restrictions_changed: updatedProfile.isParentalControlChange || false
  };
};
export const multipleProfileParams = (action, data = null) => {
  let params = null;
  if (defaultEventsList.includes(action)) {
    params = { ...getCommonParams(), ...multipleProfileCommonParams(data) };
  } else if (action === "profile_deleted") {
    params = {
      ...getCommonParams(),
      ...multipleProfileCommonParams(data),
      ...{ a_updated_profile_id: data?.updatedProfileId || "" }
    };
  } else if (action === "profile_settings_updated") {
    const { profileData, updatedProfile } = data;
    params = {
      ...getCommonParams(),
      ...multipleProfileCommonParams(profileData),
      ...{ a_updated_profile_id: profileData?.updatedProfileId || "" },
      ...updatedProfileParams(updatedProfile)
    };
  } else if (action === "profile_settings_update_discarded") {
    params = {
      ...getCommonParams(),
      ...multipleProfileCommonParams(data),
      ...{ discard_cta_location: data.location }
    };
  }
  return params;
};
